import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Попробовать ещё раз ")

import { watch, computed } from "vue";
import { useLocalStorage } from "@vueuse/core";
import { groupBy } from "lodash";

import { useAsync } from "@/use/useAsync";
import { useOperations } from "@/use/useOperations";
import { useStore } from "@/use/useStore";
import { formatDate } from "@/utils";
import { useAcsEvents } from "@/use/useAcsEvents";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";
import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";
import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";

import UiCollapse from "@/components/ui/UiCollapse.vue";
import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";
import AcsEventCell from "@/components/acs-events/AcsEventCell.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LastAcsEvents',
  setup(__props) {

const { currentUser } = useStore();
const { events, fetchAcsEvents } = useAcsEvents();

const fetchData = useAsync(() => fetchAcsEvents({ limit: "5" }), true);

const expanded = useLocalStorage("expand-last-operations", true);

const grouppedEvents = computed(() =>
  groupBy(events.value, (event) =>
    formatDate(event.date, { dateStyle: "long" })
  )
);

watch(() => currentUser.value?.id, fetchData.execute);

return (_ctx: any,_cache: any) => {
  return (_unref(events).length != 0)
    ? (_openBlock(), _createBlock(UiGroup, _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), {
        default: _withCtx(() => [
          _createVNode(UiCollapse, {
            modelValue: _unref(expanded),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(expanded) ? (expanded).value = $event : null))
          }, {
            header: _withCtx(() => [
              _createVNode(UiHeader, { title: "Последние события СКУД" }, {
                right: _withCtx(() => [
                  _createVNode(UiIcon, {
                    size: 18,
                    class: _normalizeClass([{ 'transform-gpu rotate-180': _unref(expanded) }, "transition duration-200"]),
                    icon: "ChevronDown"
                  }, null, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(UiSuspense, {
                onRetry: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData).execute())),
                pending: _unref(fetchData).isPending.value,
                failure: _unref(fetchData).isFailure.value,
                success: _unref(fetchData).isSuccess.value,
                variant: "screen",
                "has-retry": ""
              }, {
                default: _withCtx(() => [
                  (_unref(events).length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(grouppedEvents), (events, date) => {
                        return (_openBlock(), _createBlock(UiGroup, { key: date }, {
                          header: _withCtx(() => [
                            _createVNode(UiHeader, { title: date }, null, 8, ["title"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(UiCard, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events, (event) => {
                                  return (_openBlock(), _createBlock(AcsEventCell, {
                                    key: event.id,
                                    event: event
                                  }, null, 8, ["event"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    : (_openBlock(), _createBlock(UiPlaceholder, {
                        key: 1,
                        icon: "EmojiSad",
                        title: "Событий СКУД не найдено",
                        description: "К сожалению, событий о проходе ребенка в учреждение не найдено."
                      }, {
                        action: _withCtx(() => [
                          _createVNode(UiBtn, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(fetchData).execute())),
                            variant: "secondary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["pending", "failure", "success"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 16))
    : _createCommentVNode("", true)
}
}

})